module.exports = __webpack_public_path__ + "3f278fa07a1f4559312a6016cff60a8f.pdf";